import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { initFlowbite } from 'flowbite';
import { CustomSelectComponent } from '../../../../Core/custom-select/custom-select.component';
import { CommonModule, NgFor } from '@angular/common';
import { StockDetailService } from '../../../../../Services/Stock-Details/stock-detail.service';
import { StockOutService } from '../../../../../Services/Stock_Transactions/Stock_out/stock-out.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserCustomerService } from '../../../../../Services/User/Customer/user-customer.service';
import { HttpParams } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { retryWhen, switchMap, finalize } from 'rxjs/operators';
import { StockService } from '../../../../../Services/Stock/stock.service';
import { FirmSelectionService } from '../../../../../Services/firm-selection.service';
import { NotificationService } from '../../../../../Services/notification.service';
import { InvoiceService } from '../../../../../Services/Invoice/invoice.service';
import { AccountService } from '../../../../../Services/Accounts/account.service';
import { RateCutNoRateCutComponent } from '../rate-cut-no-rate-cut/rate-cut-no-rate-cut.component';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';

// NOTE: This interface can be removed if not used elsewhere, as the form dictates the structure.
export interface InvoiceItem {
  itId: string;
  metal: string;
  itemDet: string;
  qty: number;
  gsWt: number;
  ntWt: number;
  purity: string;
  wstg: number;
  fnPurity: number;
  custWstg: string;
  ffineWt: number;
  valAdd: string;
  mkgChrgs: number;
  othChrgs: number;
  totMkgChrgs: number;
  amt: number;
  mkgDisc: string;
  disc: string;
  val: number;
  cryVal: string;
  totHmc: string;
  totTax: string;
  finalVal: number;
  mrp: number;
  status: string;
}

@Component({
  selector: 'app-payment-panel',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgFor,
    CommonModule,
    ReactiveFormsModule,
    RateCutNoRateCutComponent

  ],
  templateUrl: './payment-panel.component.html',
  styleUrls: ['./payment-panel.component.css']
})
export class PaymentPanelComponent implements OnInit {

  stoneForms: number[] = [];
  public Number = Number;
  private nextStoneId = 0;
  private firmId: number | null = null;
  public firmDetails: any = null;
  public isGstApplicable = false;
  private firmSub: any; // to hold subscription so we can unsubscribe
  public isRateCutApplied = false;
  public isSaving = false;

  rateCutMetalFine: number = 0;   // GM (+ receive, - pay)
  rateCutCashAmount: number = 0; // ₹
  rateCutBalanceType: 'DR' | 'CR' = 'DR';
  isMetalCardVisible: boolean = false;
  rateCutHistoryRows: any[] = [];
  rateCutCashAmt: number = 0;
  rateCutCashWt: number = 0;
  detailsForm!: FormGroup;
  metalDetailsForm!: FormGroup;
  paymentDetailsForm!: FormGroup;
  addProductForm!: FormGroup;
  filteredBarcodes: { barcode: string; productCode: string; quantity: string; weight: string; finalValue: string }[] = [];
  barcodeList: any[] = [];
  selectedIndex = -1;
  customerId: any;
  customerDetails: any;
  invoiceItem: any;
  metalReceivedData: any;
  invoiceId!: number;
  customerType!: String;
  totalReceivedFineWeight: number = 0;
  liveReceivedFine: number = 0;
  liveReceivedValue: number = 0;
  totalRecievedNetWeight!: number;
  rateCutFixedWeight: number = 0; // GM that became cash


  rateCutData: {
    payload?: any;
    metalDelta?: number;
    cashDelta?: number;
  } = {};

  public isRateCutEnabled = false;
  public showCashSection = true;
  public hovered: 'rate' | 'no-rate' | 'cash' | null = null;

  // Values will be updated by calculateSummary()
  public summary = {
    previousAmount: 0.00,
    amount: 0.00,
    totalAmountBeforeDisc: 0.00,
    discount: 0.00,
    taxableAmount: 0.00,
    cgst: 0.00,
    sgst: 0.00,
    courierCharges: 0.00,
    roundOff: 0.00,
    grandTotal: 0.00,
    metalReceived: 0.00,
    amountPaid: 0.00,
    loyaltyAmount: 0.00,
    finalCashDeposit: 0.00,
  };

  public metalLedgerData: any[] = []; // ✅ ADD THIS

  public accountTypes: string[] = ['RAW ALLOY', 'RAW GOLD', 'RAW METAL', 'RAW SILVER', 'STOCK (INVENTORY)'];
  metalTypes: string[] = ['Silver'];
  firmTypes: string[] = ['firm 1', 'firm 2', 'firm 3', 'firm 4'];
  brandSeller: string[] = ['brand 1', 'brand 2', 'brand 3'];
  unitTypes: string[] = ['GM', 'KG', 'MG', 'CT'];
  previousMetalWt: number = 0.00;
  previousMetalType: 'DR' | 'CR' = 'DR';
  public previousInvoiceData: any[] = [];
  public prevTotals = { gold: 0, silver: 0, silverType: 'DR', stone: 0, cash: 0, cashType: 'DR' };

  public activeTabs: { [key: string]: string } = {
    gold: 'metal',
    silver: 'metal',
    stone: 'stone'
  };

  // Dynamic Account Lists
  cashAccounts: any[] = [];
  bankAccounts: any[] = [];
  cardAccounts: any[] = [];
  onlineAccounts: any[] = [];
  loyaltyAccounts: any[] = [];

  private accountSub: Subscription | null = null;

  constructor(
    private fb: FormBuilder,
    private stockDetailService: StockDetailService,
    private stockOutService: StockOutService,
    private router: Router,
    private userCustomerService: UserCustomerService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private stockService: StockService,
    private firmSelectionService: FirmSelectionService,
    private invoiceService: InvoiceService,
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
    initFlowbite();
    this.initializeForms();
    this.initPaymentDetailsForm();
    this.loadInitialData();
    this.initMetalReceivedForm();

    this.firmSub = this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      console.log("🔥 RAW FIRM OBJECT:", firm);
      console.log("🧩 Firm keys:", Object.keys(firm));

      if (!firm || !firm.id) {
        console.log("⚠️ No firm or invalid firm.id received.");
        return;
      }

      this.firmDetails = firm;
      this.firmId = firm.id;
      console.log("➡️ firm.status =", firm.status);

      const gstStatus = Number(firm.status);

      console.log("💡 Final GST status detected =", gstStatus);

      this.isGstApplicable = (gstStatus === 0 || gstStatus === 2);
      console.log("📌 Is GST Applicable?", this.isGstApplicable);

      // Apply GST functionality
      this.paymentDetailsForm.patchValue({
        isCgstSgstApplicable: this.isGstApplicable,
        in_cgst_percent: this.isGstApplicable ? 1.5 : 0,
        in_sgst_percent: this.isGstApplicable ? 1.5 : 0,
      }, { emitEvent: false });

      // Fetch dynamic accounts for the firm
      if (this.firmId) {
        this.fetchAccounts(this.firmId);
      }

      this.calculateSummary();
    });

    this.paymentDetailsForm.valueChanges.subscribe(() => {
      this.calculateSummary();
    });

    this.paymentDetailsForm.get('in_discount_percent')?.valueChanges.subscribe(value => {
      this.calculateDiscountFromPercent(value);
    });

    this.paymentDetailsForm.get('in_total_discount')?.valueChanges.subscribe(value => {
      this.calculatePercentFromDiscount(value);
    });

  }

  ngOnDestroy(): void {
    if (this.firmSub) {
      this.firmSub.unsubscribe();
    }
    if (this.accountSub) {
      this.accountSub.unsubscribe();
    }
  }

  fetchAccounts(firmId: number): void {
    this.accountService.getGroupedAccounts({ firm_id: firmId }).subscribe({
      next: (res: any) => {
        const grouped = res.data || {};
        const currentAssets = (grouped['Assets'] && grouped['Assets']['Current Assets']) || {};
        const operatingExpenses = (grouped['Expense'] && grouped['Expense']['Operating Expenses']) || {};

        this.cashAccounts = currentAssets['Cash'] || [];
        this.bankAccounts = currentAssets['Bank Account'] || [];
        this.cardAccounts = currentAssets['Card Payment'] || [];
        this.onlineAccounts = currentAssets['Online Payment'] || [];
        this.loyaltyAccounts = operatingExpenses['Discount Paid'] || [];

        // Patch defaults if the current values are not in the new lists
        const form = this.paymentDetailsForm.getRawValue();

        if (this.cashAccounts.length > 0 && !this.cashAccounts.some(a => (a.acc_id || a.id).toString() === form.in_payment_account_cash?.toString())) {
          this.paymentDetailsForm.patchValue({ in_payment_account_cash: (this.cashAccounts[0].acc_id || this.cashAccounts[0].id).toString() });
        }
        if (this.bankAccounts.length > 0 && !this.bankAccounts.some(a => (a.acc_id || a.id).toString() === form.in_payment_account_bank?.toString())) {
          this.paymentDetailsForm.patchValue({ in_payment_account_bank: (this.bankAccounts[0].acc_id || this.bankAccounts[0].id).toString() });
        }
        if (this.cardAccounts.length > 0 && !this.cardAccounts.some(a => (a.acc_id || a.id).toString() === form.in_payment_account_card?.toString())) {
          this.paymentDetailsForm.patchValue({ in_payment_account_card: (this.cardAccounts[0].acc_id || this.cardAccounts[0].id).toString() });
        }
        if (this.onlineAccounts.length > 0 && !this.onlineAccounts.some(a => (a.acc_id || a.id).toString() === form.in_payment_account_online?.toString())) {
          this.paymentDetailsForm.patchValue({ in_payment_account_online: (this.onlineAccounts[0].acc_id || this.onlineAccounts[0].id).toString() });
        }
        if (this.loyaltyAccounts.length > 0 && !this.loyaltyAccounts.some(a => (a.acc_id || a.id).toString() === form.in_loyalty_account_id?.toString())) {
          this.paymentDetailsForm.patchValue({ in_loyalty_account_id: (this.loyaltyAccounts[0].acc_id || this.loyaltyAccounts[0].id).toString() });
        }
      },
      error: (err) => {
        console.error('Error fetching accounts:', err);
      }
    });
  }

  calculateDiscountFromPercent(percent: any) {
    percent = parseFloat(percent) || 0;
    const baseAmount = this.summary.amount + this.getSilverValue(); // item total + silver value

    if (percent <= 0) {
      this.paymentDetailsForm.patchValue({ in_total_discount: 0 }, { emitEvent: false });
      this.summary.discount = 0;
    } else {
      const discountAmt = (baseAmount * percent) / 100;
      this.paymentDetailsForm.patchValue({ in_total_discount: discountAmt.toFixed(2) }, { emitEvent: false });
      this.summary.discount = discountAmt;
    }

    this.calculateSummary();
  }

  calculatePercentFromDiscount(amount: any) {
    amount = parseFloat(amount) || 0;
    const baseAmount = this.summary.amount + this.getSilverValue();

    if (baseAmount <= 0 || amount <= 0) {
      this.paymentDetailsForm.patchValue({ in_discount_percent: 0 }, { emitEvent: false });
      this.summary.discount = 0;
    } else {
      const percent = (amount / baseAmount) * 100;
      this.paymentDetailsForm.patchValue({ in_discount_percent: percent.toFixed(2) }, { emitEvent: false });
      this.summary.discount = amount;
    }

    this.calculateSummary();
  }

  getSilverValue(): number {
    // ✅ If RateCut / NoRateCut popup was used
    if (this.isRateCutApplied) {
      return Math.abs(this.rateCutCashAmount || 0);
    }

    // ✅ Default behaviour (no popup usage)
    // 🔥 FIX: User requested NO auto-calculation of silver value for cash
    return 0; // this.amountWithSilverValue || 0;
  }



  initMetalReceivedForm() {
    const randomCode = Math.random().toString(36).substring(2, 6).toUpperCase();

    this.metalDetailsForm = this.fb.group({
      st_metal_type: ['Silver'],
      st_item_name: ['OldSilver'],

      // 👇 USE STRING "0.000"
      st_gs_weight: ['0.000'],
      st_gs_weight_type: ['GM'],

      st_less_weight: ['0.000'],
      st_less_weight_type: ['GM'],

      st_tunch: ['100'],

      st_net_weight: [{ value: '0.000', disabled: true }],
      st_net_weight_type: ['GM'],

      st_fine_weight: [{ value: '0.000', disabled: true }],
      st_lbr_weight: ['0.000'],
      st_ffn_weight: ['0.000'],

      // st_metal_rate: ['0.00'],
      st_valuation: [{ value: '0.00', disabled: true }],
      st_avg_metal_rate: [{ value: '0.00', disabled: true }],

      st_item_code: [`MRCODE_${randomCode}`],
      st_type: ['metal_received'],
      st_invoice_number: [''],
      st_purity: ['92.5']
    });

    this.metalDetailsForm.valueChanges.subscribe(() => {
      this.calculateNetWeight();
      this.calculateMetalReceivedValue();
    });

    if (this.invoiceItem?.length) {
      this.metalDetailsForm.patchValue({
        st_invoice_number: this.invoiceItem[0].stout_invoice_number
      });
    }
  }

  calculateNetWeight() {
    const gs = +this.metalDetailsForm.get('st_gs_weight')?.value || 0;
    const less = +this.metalDetailsForm.get('st_less_weight')?.value || 0;

    const net = gs - less;

    this.metalDetailsForm.patchValue({
      st_net_weight: net > 0 ? net.toFixed(3) : 0
    }, { emitEvent: false });
  }

  calculateFineWeight() {
    const net = +this.metalDetailsForm.get('st_net_weight')?.value || 0;
    const tunch = +this.metalDetailsForm.get('st_tunch')?.value || 0;

    const fine = (net * tunch) / 100;

    this.metalDetailsForm.patchValue({
      st_fine_weight: fine.toFixed(3)
    }, { emitEvent: false });
  }

  calculateNetWeightFromTunch() {
    const gross = parseFloat(this.metalDetailsForm.get('st_gs_weight')?.value || '0');
    const tunch = parseFloat(this.metalDetailsForm.get('st_tunch')?.value || '0');

    if (!isNaN(gross) && !isNaN(tunch) && gross > 0 && tunch > 0) {
      const net = (gross * tunch) / 100;
      const roundedNet = parseFloat(net.toFixed(2));
      this.metalDetailsForm.patchValue({ st_net_weight: roundedNet }, { emitEvent: false });
    } else {
      this.metalDetailsForm.patchValue({ st_net_weight: null }, { emitEvent: false });
    }
  }

  calculateMetalReceivedValue() {
    const net = +this.metalDetailsForm.get('st_net_weight')?.value || 0;
    const tunch = +this.metalDetailsForm.get('st_tunch')?.value || 0;
    // const rate = +this.metalDetailsForm.get('st_metal_rate')?.value || 0;

    const fine = +(net * (tunch / 100)).toFixed(3);
    const lbr = fine;
    const ffn = fine;
    // const valuation = +((fine * rate) / 1000).toFixed(2);
    //  const avgRate = rate * 9;

    this.metalDetailsForm.patchValue({
      st_fine_weight: fine,
      st_lbr_weight: lbr,
      st_ffn_weight: ffn,
      //  st_valuation: valuation,
      //  st_avg_metal_rate: avgRate
    }, { emitEvent: false });

    // 🔥 THIS IS THE MISSING LINK
    this.liveReceivedFine = fine;
    // this.liveReceivedValue = valuation;

    // 🔥 update card + summary immediately
    this.buildMetalLedgerData();
    this.calculateSummary();
  }

  private buildMetalLedgerData(): void {
    const baseSilver = this.prevTotals.silver || 0;
    const baseSilverType = (this.prevTotals as any).silverType || 'DR';
    const baseCash = this.prevTotals.cash || 0;
    const invoiceSilver = this.totalFine || 0;

    // 🔥 FIX: SL Received now ONLY includes physical metal
    const physicalReceived =
      (this.totalReceivedFineWeight || 0) +
      (this.liveReceivedFine || 0) +
      (this.rateCutMetalFine || 0);

    const openingSigned = baseSilverType === 'CR' ? -baseSilver : baseSilver;

    // 🔥 PRE-SETTLEMENT BALANCE (Starting point for the popup table)
    const preSettlementBalance = openingSigned + invoiceSilver - (this.totalReceivedFineWeight || 0) - (this.liveReceivedFine || 0);

    // 🔥 FINAL BALANCE: Subtracts both Physical and Fixed weight
    const finalSilverBalance = openingSigned + invoiceSilver - physicalReceived - this.rateCutFixedWeight;

    this.metalLedgerData = [
      {
        metal: 'SILVER',
        openingBalance: baseSilver,
        openingBalanceType: baseSilverType,
        soldFine: invoiceSilver,

        // Shows only physical received in snapshot
        receivedFine: physicalReceived,

        balance: Math.abs(finalSilverBalance),
        balanceType: finalSilverBalance >= 0 ? 'DR' : 'CR',
        preSettlementBalance: preSettlementBalance, // Add this
        currRate: 0,

        // UI Fields for the Card
        cashSlBal: Math.abs(this.rateCutCashAmount || 0), // 500.00
        cashSlWt: Math.abs(this.rateCutFixedWeight || 0)  // 5.00 GM
      },
      // ... rest of the AMT ledger
      //  ADD THIS BACK (THIS FIXES SL Previous Bal)
      {
        metal: 'AMT',
        openingBalance: Math.abs(baseCash),
        openingBalanceType: baseCash >= 0 ? 'DR' : 'CR',

        receivedFine: 0,
        soldFine: 0,

        balance: Math.abs(baseCash),
        balanceType: baseCash >= 0 ? 'DR' : 'CR',

        currRate: 0
      }
    ];
  }

  initPaymentDetailsForm() {
    this.paymentDetailsForm = this.fb.group({
      isCgstSgstApplicable: [true],
      isMetalExchangeApplicable: [false],

      amountPaidReceiveOption: ['amountReceived'],
      in_salesperson_name: [''],

      in_discount_narration: [''],
      in_discount_coupon: [''],
      in_discount_percent: [''], // UI helper, not in DB
      in_total_discount: [''],

      // Courier Section
      in_courier_charges: [0],
      in_courier_info: [''],

      // Tax Section (Percentages are UI helpers)
      in_cgst_percent: [1.5],
      in_sgst_percent: [1.5],
      in_cgst: [{ value: 0, disabled: true }],
      in_sgst: [{ value: 0, disabled: true }],

      // Payment Methods: Cash
      in_payment_account_cash: ['2893'],
      in_cash_narration: [''],
      in_cash_amount: [0],

      // Payment Methods: Bank
      in_payment_account_bank: ['2892'],
      in_cheque_narration: [''], // Corresponds to Cheque/NEFT/IMPS field
      in_bank_amount: [0],

      // Payment Methods: Card
      in_payment_account_card: ['2951'],
      in_card_number: [''],
      in_card_amount: [''],
      in_card_charges_percent: [''],
      in_card_charges_amount: [''],
      in_total_card_amount: [0],

      // Payment Methods: Online
      in_payment_account_online: ['2952'],
      in_online_narration: [''],
      in_online_amount: [''],
      in_online_commission_percent: [''], // UI helper, not in DB
      in_online_commission_amount: [''],  // UI helper, not in DB
      in_total_online_amount: [0],

      // Loyalty Points Section
      in_loyalty_account_id: ['2924'], // UI helper, not in DB
      loyaltyOpening: [''],
      loyaltyClosing: [''],
      loyaltyGain: [''],
      in_loyalty_amount: [0],

      // Other Info Section
      in_notes: [''], // Corresponds to "Payment Other Info"
      reminder: ['NotSelected'],
      in_firm_id: [''],

      // All other summary fields that are calculated and stored
      in_previous_amount: [0],
      in_sub_total: [{ value: 0, disabled: true }],
      in_total_amount_before_disc: [{ value: 0, disabled: true }],
      in_taxable_amount: [{ value: 0, disabled: true }],
      in_round_off: [0],
      in_grand_total: [{ value: 0, disabled: true }],
      in_metal_received: [{ value: 0, disabled: true }],
      in_amount_paid: [{ value: 0, disabled: true }],
      in_final_cash_deposit: [{ value: 0, disabled: true }],
      in_balance_due: [{ value: 0, disabled: true }],
    });
  }

  addReceivedMetal() {
    this.stockService.createStockEntry(this.metalDetailsForm.value).subscribe({
      next: (response: any) => {
        this.notificationService.showSuccess("Metal received entry added successfully!", "Success");
        this.liveReceivedFine = 0;
        this.liveReceivedValue = 0;
        this.getMetalReceivedData();
        this.clearMetalReceivedForm();
        this.buildMetalLedgerData();   // ✅ ADD THIS

      },
      error: (error: any) => {
        console.error("Error while adding metal entry:", error);
        this.notificationService.showError("Failed to add metal entry. Please try again.", "Error");
      }
    });
  }

  getMetalReceivedData() {
    const params = new HttpParams().set('invoice_number', this.invoiceItem[0]?.stout_invoice_number);
    this.stockService.getStockEntriesWithParams(params).subscribe((response: any) => {
      // 🔥 FIX: Filter out rate cut settlements to avoid double counting
      this.metalReceivedData = response.data.filter((item: any) => item.st_type !== 'rate_cut_settlement');

      this.totalReceivedFineWeight = this.metalReceivedData.reduce(
        (sum: number, item: any) => sum + (Number(item.st_fine_weight) || 0),
        0
      );

      this.totalRecievedNetWeight = this.metalReceivedData.reduce(
        (sum: number, item: any) => sum + (parseFloat(item.st_net_weight) || 0),
        0
      );
      this.buildMetalLedgerData(); // ✅ ADD HERE TOO
      this.calculateSummary();
    });
  }

  deleteReceivedMetal(id: any) {
    this.stockService.deleteStockEntry(id).subscribe({
      next: (response: any) => {
        this.notificationService.showSuccess("Metal entry deleted successfully!", "Success");
        this.getMetalReceivedData();

      },
      error: (error: any) => {
        console.error("Error while deleting metal entry:", error);
        this.notificationService.showError("Failed to delete metal entry. Please try again.", "Error");
      }
    });
  }

  deleteInvoiceItem(itemId: number): void {
    if (!confirm('Are you sure you want to remove this item from the invoice?')) {
      return;
    }

    this.stockOutService.deleteStockOutEntry(itemId).subscribe({
      next: (response) => {
        this.notificationService.showSuccess('Item removed and stock rolled back successfully!', 'Success');

        // Refresh the UI efficiently
        // Find the index of the item to remove
        const index = this.invoiceItem.findIndex((item: any) => item.stout_id === itemId);
        if (index > -1) {
          // Remove the item from the local array
          this.invoiceItem.splice(index, 1);
          // Recalculate the summary
          this.calculateSummary();
        } else {
          // Fallback to a full reload if the item isn't found locally for some reason
          this.loadInitialData();
        }
      },
      error: (err) => {
        console.error('Error deleting stock out entry:', err);
        const errorMessage = err.error?.message || 'Failed to remove item. Please try again.';
        this.notificationService.showError(errorMessage, 'Error');
      }
    });
  }

  clearMetalReceivedForm() {
    const randomCode = Math.random().toString(36).substring(2, 6).toUpperCase();
    this.metalDetailsForm.reset({
      st_metal_type: 'Silver',
      st_type: 'metal_received',
      st_purity: 92.5,
      st_tunch: 100,
      st_gs_weight_type: 'GM',
      st_less_weight_type: 'GM',
      st_net_weight_type: 'GM',
      st_item_code: `MRCODE_${randomCode}`,
    })
    if (this.invoiceItem && this.invoiceItem.length > 0) {
      this.metalDetailsForm.patchValue({
        st_invoice_number: this.invoiceItem[0].stout_invoice_number
      });
    }
    this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      if (firm && firm.id) {
        this.metalDetailsForm.patchValue({
          st_firm_id: firm.id
        });
      }
    });
  }

  private initializeForms(): void {
    this.addStoneForm();
    this.detailsForm = this.fb.group({
      addDetail: [false],
      addEcom: [false],
      fixMrp: [false]
    });
    this.initSelectBarcodeForm();
  }

  private loadInitialData(): void {
    this.route.paramMap.pipe(
      switchMap(params => {
        this.customerId = params.get('id');
        return this.getCustomerDetailsObservable();
      }),
      switchMap((customerResp: any) => {
        this.customerDetails = customerResp.data;
        this.customerType = this.customerDetails?.user_customer_type;

        const barcodeObs = this.getBarcodeDataObservable();
        const invoiceObs = this.getInvoiceItemsObservable();

        const historyParams = new HttpParams()
          .set('customer_id', this.customerId)
          .set('invoice_status', 'saved');

        const pastInvoicesObs = this.invoiceService.getInvoices(historyParams);

        return forkJoin({
          invoiceItems: invoiceObs,
          barcodeData: barcodeObs,
          pastInvoices: pastInvoicesObs,
          customerDetails: Promise.resolve(customerResp) as any
        });
      })
    ).subscribe({
      next: (response: any) => {
        this.invoiceItem = response.invoiceItems.data;
        this.barcodeList = this.processBarcodeData(response.barcodeData.data);

        if (this.customerDetails) {
          const previousAmount = parseFloat(this.customerDetails.balance_due) || 0;
          this.paymentDetailsForm.patchValue({
            in_previous_amount: previousAmount.toFixed(2)
          }, { emitEvent: false });
        }

        // 🔥 FIX: Passed response.pastInvoices directly (removed .data)
        this.processPreviousLedger(response.pastInvoices);

        if (this.invoiceItem && this.invoiceItem.length > 0) {
          this.metalDetailsForm.patchValue({
            st_invoice_number: this.invoiceItem[0].stout_invoice_number
          });
          this.getMetalReceivedData();
        } else {
          this.buildMetalLedgerData();
          this.calculateSummary();
        }
      },
      error: (err) => {
        console.error('❌ Error in loadInitialData:', err);
      }
    });
  }

  private processPreviousLedger(pastInvoices: any[]): void {
    if (!pastInvoices || pastInvoices.length === 0) {
      this.previousInvoiceData = [];
      return;
    }

    this.previousInvoiceData = pastInvoices
      .filter(inv => Number(inv.customer_id) === Number(this.customerId))
      // 🔥 FIX: Exclude current invoice to prevent recursion/duplication
      .filter(inv => inv.invoice_number !== this.invoiceItem[0]?.stout_invoice_number)
      .filter(inv => {
        // 🔥 FIX: Show invoice if ANY balance (Cash, Silver, or Gold) is pending
        const cash = parseFloat(inv.balance_due) || 0;
        let silver = this.getSilverBalanceFromPayload(inv.in_rate_cut_payload);

        if (silver === null || silver === undefined || silver === 0) {
          silver = parseFloat(inv.in_balance_silver_wt || inv.balance_silver_wt || inv.total_silver_wt) || 0;
        }
        const gold = parseFloat(inv.balance_gold_wt || inv.total_gold_wt) || 0;
        return cash !== 0 || silver !== 0 || gold !== 0; // Keep if any non-zero balance
      })
      .map(inv => {
        const rawGold = parseFloat(inv.balance_gold_wt || inv.in_balance_gold_wt || inv.total_gold_wt) || 0;
        let rawSilver = this.getSilverBalanceFromPayload(inv.in_rate_cut_payload);

        if (rawSilver === null || rawSilver === undefined || rawSilver === 0) {
          rawSilver = parseFloat(inv.in_balance_silver_wt || inv.balance_silver_wt || inv.total_silver_wt) || 0;
        }
        const rawCash = parseFloat(inv.balance_due) || 0;

        return {
          invoice_no: inv.invoice_number,

          gold_wt: Math.abs(rawGold),
          gold_raw: rawGold,
          gold_type: rawGold >= 0 ? 'DR' : 'CR',

          silver_wt: Math.abs(rawSilver),
          silver_raw: rawSilver,
          silver_type: rawSilver >= 0 ? 'DR' : 'CR',

          stone_wt: parseFloat(inv.total_stone_wt) || 0,

          cash_bal: Math.abs(rawCash),
          cash_raw: rawCash,
          cash_type: rawCash >= 0 ? 'DR' : 'CR',

          isSilverSelected: true,
          isCashSelected: true
        };
      });

    // We must calculate totals ONCE after loading to set the initial 0.00 DR
    this.calculatePrevTotals();
  }


  calculateSummary(): void {
    const form = this.paymentDetailsForm.getRawValue();

    const subTotal = this.invoiceItem?.reduce((acc: number, item: any) => acc + Number(item.stout_final_amount || 0), 0) || 0;

    const previousAmount = parseFloat(form.in_previous_amount) || 0;
    const discount = parseFloat(form.in_total_discount) || 0;
    const courierCharges = parseFloat(form.in_courier_charges) || 0;

    let taxableAmount = 0;
    let cgst = 0;
    let sgst = 0;
    let totalAmountBeforeDisc = 0;

    // 2. Conditional Tax Calculation Logic
    if (form.isCgstSgstApplicable) {
      const cgstPercent = parseFloat(form.in_cgst_percent) || 0;
      const sgstPercent = parseFloat(form.in_sgst_percent) || 0;
      const totalTaxRate = (cgstPercent + sgstPercent) / 100;
      const divisor = 1 + totalTaxRate;

      // Calculate pre-tax base amount for new items + silver value
      const preTaxBaseAmountItems = (subTotal + this.getSilverValue()) / divisor;

      // Amount subject to discount/tax: Previous amount + new pre-tax total
      totalAmountBeforeDisc = previousAmount + subTotal;

      taxableAmount = preTaxBaseAmountItems - discount;
      cgst = taxableAmount * (cgstPercent / 100);
      sgst = taxableAmount * (sgstPercent / 100);

    } else {
      const silverValue = (this.totalFine - this.totalRecievedNetWeight) *
        (this.amountWithSilverValue / this.totalFine);

      // 🔥 FIX IS HERE: totalAmountBeforeDisc should NOT include previousAmount, 
      // as it's added back in the final rounding step.
      // 🔥 FIX: User requested to NOT add silver value to cash total
      totalAmountBeforeDisc = subTotal; // + silverValue;

      taxableAmount = totalAmountBeforeDisc - discount;

      cgst = 0;
      sgst = 0;
    }

    // 3. *** NEW ROUNDING LOGIC ***
    // This is where previousAmount is correctly included once.
    // Base total same as UI Total Amount
    const totalAmount = subTotal + this.getSilverValue();

    // Add previous, discount, courier if required
    const totalBeforeRounding =
      totalAmount
      + previousAmount
      - discount
      + courierCharges
      + cgst
      + sgst;

    const roundedTotal = Math.round(totalBeforeRounding);
    const roundOff = roundedTotal - totalBeforeRounding;

    const grandTotal = roundedTotal;

    // *** END OF NEW ROUNDING LOGIC ***


    // 4. Calculate payments and balances
    // 🔥 Metal Received = Normal Received + RateCut Received
    const metalReceived =
      (form.isMetalExchangeApplicable
        ? this.getMetalReceivedValuation()
        : 0)
      + (this.rateCutMetalFine || 0);

    const loyaltyAmount = parseFloat(form.in_loyalty_amount) || 0;
    const cashPaid = parseFloat(form.in_cash_amount) || 0;
    const bankPaid = parseFloat(form.in_bank_amount) || 0;
    const cardPaid = parseFloat(form.in_total_card_amount) || 0;
    const onlinePaid = parseFloat(form.in_total_online_amount) || 0;


    const amountPaid = cashPaid + bankPaid + cardPaid + onlinePaid;
    const balanceDue = grandTotal - amountPaid - loyaltyAmount;

    // 5. Update the summary object for display
    this.summary = {
      previousAmount: previousAmount,
      amount: subTotal,
      totalAmountBeforeDisc: totalAmountBeforeDisc,
      discount: discount,
      taxableAmount: taxableAmount,
      cgst: cgst,
      sgst: sgst,
      courierCharges: courierCharges,
      roundOff: roundOff, // Use the calculated roundOff value here
      grandTotal: grandTotal,
      metalReceived: metalReceived,
      amountPaid: amountPaid,
      loyaltyAmount: loyaltyAmount,
      finalCashDeposit: balanceDue
    };

    // 6. Patch all calculated values back into the form
    this.paymentDetailsForm.patchValue({
      in_sub_total: subTotal.toFixed(2),
      in_total_amount_before_disc: totalAmountBeforeDisc.toFixed(2),
      in_taxable_amount: taxableAmount.toFixed(2),
      in_cgst: cgst.toFixed(2),
      in_sgst: sgst.toFixed(2),
      in_round_off: roundOff.toFixed(2), // Patch the calculated roundOff value
      in_grand_total: grandTotal.toFixed(2),
      in_metal_received: metalReceived.toFixed(2),
      in_amount_paid: amountPaid.toFixed(2),
      in_final_cash_deposit: balanceDue.toFixed(2),
      in_balance_due: balanceDue.toFixed(2)
    }, { emitEvent: false });
  }

  private processBarcodeData(data: any[]): any[] {
    return data
      .filter((item: any) => item.stock_status !== 'sold')
      .map((item: any) => ({
        barcode: item.std_barcode,
        productCode: item.std_item_code,
        quantity: item.std_quantity,
        weight: item.std_total_wt,
        finalValue: item.std_unit_price,
      }));
  }

  private getInvoiceItemsObservable(): Observable<any> {
    const params = new HttpParams()
      .set('customer_id', this.customerId)
      .set('invoice_status', 'pending_invoice');
    return this.stockOutService.getStockOutEntries(params);
  }

  private getBarcodeDataObservable(): Observable<any> {
    if (this.customerDetails?.user_customer_type === "Wholesale" || this.customerDetails?.user_customer_type === "Retailer") {
      const params = new HttpParams().set('std_product_type', 'lot-wise');
      return this.stockDetailService.getStockDetails(params);
    } else {
      const params = new HttpParams().set('std_product_type', 'piece-wise');
      return this.stockDetailService.getStockDetails(params);
    }
  }

  private getCustomerDetailsObservable(): Observable<any> {
    return this.userCustomerService.getUserCustomerById(this.customerId);
  }

  setActiveTab(commodity: string, tab: string): void {
    this.activeTabs[commodity] = tab;
  }

  addStoneForm(): void { this.stoneForms.push(this.nextStoneId++); }
  removeStoneForm(idToRemove: number): void { this.stoneForms = this.stoneForms.filter(id => id !== idToRemove); }

  goToCashDetails(): void {
    this.isRateCutEnabled = false;
    this.showCashSection = true;
  }

  getBarcodeData() {
    const params = new HttpParams();
    this.stockDetailService.getStockDetails(params).subscribe({
      next: (response: any) => {
        this.barcodeList = response.data
          .filter((item: any) => item.stock_status !== 'sold')
          .map((item: any) => ({
            barcode: item.std_barcode,
            productCode: item.std_item_code,
            quantity: item.std_quantity,
            weight: item.std_total_wt,
            finalValue: item.std_unit_price,
          }));
      },
      error: (error: any) => {
        console.error('Error fetching barcode data:', error);
      }
    });
  }

  getEffectiveSilverValue(): number {
    // Popup used → take rate cut cash
    if (this.isRateCutApplied) {
      return Number(this.rateCutCashAmount) || 0;
    }

    // Default flow
    return Number(this.amountWithSilverValue) || 0;
  }


  initSelectBarcodeForm() {
    this.addProductForm = this.fb.group({
      start_range_1: ['']
    });
  }

  onFocusInput() {
    this.filteredBarcodes = [...this.barcodeList];
    this.selectedIndex = -1;
  }

  onBlurInput(): void {
    setTimeout(() => {
      this.filteredBarcodes = [];
    }, 200);
  }

  onKeyDown(event: KeyboardEvent) {
    const maxIndex = this.filteredBarcodes.length - 1;

    if (event.key === 'ArrowDown') {
      this.selectedIndex = (this.selectedIndex + 1) > maxIndex ? 0 : this.selectedIndex + 1;
      event.preventDefault();
    }
    else if (event.key === 'ArrowUp') {
      this.selectedIndex = (this.selectedIndex - 1) < 0 ? maxIndex : this.selectedIndex - 1;
      event.preventDefault();
    }
    else if (event.key === 'Enter' && this.selectedIndex >= 0) {
      this.onSelectBarcode(this.filteredBarcodes[this.selectedIndex].barcode);
      event.preventDefault();
    }
  }

  onSelectBarcode(barcode: string) {
    this.addProductForm.get('start_range_1')?.setValue(barcode);
    this.filteredBarcodes = [];
  }

  onGoClick(type: 'add' | 'return') {
    const barcode = this.addProductForm.get('start_range_1')?.value;
    this.stockOutService.setBarcode(barcode);
    setTimeout(() => {
      if (this.customerDetails?.user_customer_type === "Wholesale" || this.customerDetails?.user_customer_type === "Retailer") {
        this.router.navigate(['sell-details-lot', this.customerId]);
      } else {
        this.router.navigate(['sell-details-lot', this.customerId]);
      }
    }, 0);
  }

  get totalQty(): number {
    return this.invoiceItem?.reduce((sum: number, item: { stout_quantity: any; }) => sum + (Number(item.stout_quantity) || 0), 0) || 0;
  }

  get totalWeight(): number {
    return this.invoiceItem?.reduce((sum: number, item: { stout_total_wt: any; }) => sum + (Number(item.stout_total_wt) || 0), 0) || 0;
  }

  get totalFine(): number {
    return this.invoiceItem?.reduce((sum: number, item: { stout_fine_weight: any; }) => sum + (Number(item.stout_fine_weight) || 0), 0) || 0;
  }

  get amountWithSilverValue(): number {
    return this.invoiceItem?.reduce((sum: number, item: { stout_total_amount: any; }) => sum + (Number(item.stout_total_amount) || 0), 0) || 0;
  }

  get finalValuation(): number {
    return this.invoiceItem?.reduce((sum: number, item: { stout_final_amount: any; }) => sum + (Number(item.stout_final_amount) || 0), 0) || 0;
  }

  get totalMetalReceivedValue(): number {
    return this.metalReceivedData?.reduce((sum: number, item: { st_valuation: any; }) => sum + (Number(item.st_valuation) || 0), 0) || 0;
  }

  storeInvoiceData(action: 'save' | 'print' | 'rough' = 'save') {
    if (this.isSaving) {
      return;
    }

    if (action === 'rough' && !this.isRateCutApplied) {
      Swal.fire({
        title: 'Settlement Required',
        text: 'Please open the Rate Cut / Settlement panel to confirm the metal balance before generating a rough estimate.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c19725',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Open Settlement',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.openRateCut();
        }
      });
      return;
    }

    const invoicePayload = {
      ...this.paymentDetailsForm.getRawValue(),

      in_invoice_number: this.invoiceItem[0]?.stout_invoice_number || `INV-${Date.now()}`,
      in_previous_amount: this.paymentDetailsForm.get('in_previous_amount')?.value || 0,
      in_previous_silver_wt: (this.prevTotals?.silver || 0) * (this.prevTotals?.silverType === 'CR' ? -1 : 1),
      in_customer_id: this.customerId,
      in_customer_name: this.customerDetails?.name,
      in_billing_name: this.customerDetails?.user_name,
      in_firm_id: this.firmId,
      in_invoice_date: new Date().toISOString().split('T')[0],

      // 🔥 1. PERSISTENCE FIX: Stringify the payload before sending to the database
      in_rate_cut_payload: this.rateCutData.payload ?? null,
      in_rate_cut_metal_delta: this.rateCutData.metalDelta || 0,
      in_rate_cut_cash_delta: this.rateCutData.cashDelta || 0,

      // 🔥 METAL BALANCE PERSISTENCE (COLUMN STRATEGY)
      in_balance_silver_wt: (
        (this.totalFine || 0) -
        (this.totalReceivedFineWeight || 0) -
        (this.liveReceivedFine || 0) -
        (this.rateCutMetalFine || 0)
      ).toFixed(3),

      in_balance_gold_wt: 0, // Placeholder

      // 🔥 FIX: Send detailed settlement info (Partial Settlement Support)
      in_settled_invoices: this.previousInvoiceData
        .filter(inv => inv.isSilverSelected || inv.isCashSelected)
        .map(inv => ({
          invoice_number: inv.invoice_no,
          settle_cash: inv.isCashSelected,
          settle_silver: inv.isSilverSelected
        }))
    };

    /**
     * NOTE: Balance Due is automatically handled by the backend's journal entry logic.
     * If a non-zero balance exists, it is debited to the "SUNDRY DEBTORS" account in the General Journal.
     */


    // remove UI-only helpers
    delete invoicePayload.isCgstSgstApplicable;
    delete invoicePayload.isMetalExchangeApplicable;
    delete invoicePayload.in_loyalty_account_id;
    delete invoicePayload.loyaltyOpening;
    delete invoicePayload.loyaltyClosing;
    delete invoicePayload.loyaltyGain;
    delete invoicePayload.amountPaidReceiveOption;
    delete invoicePayload.reminder;

    this.isSaving = true;
    this.invoiceService.createInvoice(invoicePayload)
      .pipe(finalize(() => { this.isSaving = false; }))
      .subscribe({
      next: (response: any) => {
        this.notificationService.showSuccess("Invoice created successfully!", "Success");
        this.invoiceId = response.data.id;

        this.clearPreviousInvoiceBalances();


        // 🔥 2. Create the final metal transaction record
        this.createFinalMetalTransaction();

        // 🔥 STATE RESET: Ensure UI is clean for next transaction
        this.invoiceItem = [];
        this.rateCutData = {};
        this.isRateCutApplied = false;
        this.rateCutMetalFine = 0;
        this.rateCutCashAmount = 0;
        this.rateCutFixedWeight = 0;
        this.rateCutHistoryRows = [];
        this.isMetalCardVisible = false;

        this.getMetalReceivedData();
        this.loadInitialData();
        this.paymentDetailsForm.reset();

        // 👉 handle both cases here
        if (action === 'rough') {
          this.router.navigate([`rough-estimate-invoice/${this.invoiceId}`]);
        } else if (action === 'print') {
          if (this.customerType === "Wholesale" || this.customerType === "Retailer") {
            this.router.navigate([`invoice-b2b/${this.invoiceId}`]);
          } else {
            this.router.navigate([`invoice-panel/${this.invoiceId}`]);
          }
        }
      },
      error: (error: any) => {
        console.error("Error while creating invoice:", error);
        this.notificationService.showError("Failed to create invoice. Please try again.", "Error");
      }
    });
  }
  // Add this method to your PaymentPanelComponent class
  // Replace this function in payment-panel.component.ts

  createFinalMetalTransaction() {
    const metalDelta = this.rateCutData.metalDelta || 0;
    const cashDelta = this.rateCutData.cashDelta || 0;

    if (metalDelta === 0 && cashDelta === 0) return; // Nothing to record

    // 🔥 FIX 1: Define transactionPayload as a Record<string, any> to allow indexed access
    const transactionPayload: Record<string, any> = {
      st_metal_type: this.rateCutData.payload?.metal || 'SILVER',
      st_type: 'rate_cut_settlement',
      st_fine_weight_delta: metalDelta.toFixed(3), // Format decimals for storage
      st_cash_delta: cashDelta.toFixed(2),         // Format decimals for storage
      st_customer_id: this.customerId,
      st_firm_id: this.firmId,
      st_reference_invoice: this.invoiceItem[0]?.stout_invoice_number,
      st_notes: 'Final settlement from Rate Cut Ledger'
    };

    const formData = new FormData();

    // 🔥 FIX 2: Ensure the value appended is explicitly a string
    for (const key in transactionPayload) {
      if (transactionPayload.hasOwnProperty(key)) {
        // Cast the value to string for formData.append
        formData.append(key, String(transactionPayload[key]));
      }
    }

    // Now call the service with the correctly formatted FormData object
    this.stockService.createStockEntry(formData).subscribe({
      next: () => console.log('Metal Settlement Transaction Recorded Successfully.'),
      error: (err) => console.error('Failed to record final metal transaction:', err)
    });
  }


  narrationValue: string = '';
  showOptions = false;
  options = ["PhonePe", "GPay", "Paytm"];
  filteredOptions: string[] = [...this.options];

  filterOptions() {
    this.filteredOptions = this.options.filter(opt =>
      opt.toLowerCase().includes(this.narrationValue.toLowerCase())
    );
  }

  selectOption(option: string) {
    this.narrationValue = option;
    this.showOptions = false;
  }

  hideOptions() {
    setTimeout(() => this.showOptions = false, 200); // delay so click works
  }


  // Rate cut No-Rate Cut

  isRateCutVisible: boolean | undefined;

  openRateCut() {
    // 🔥 ALWAYS rebuild ledger using latest metal received data
    this.buildMetalLedgerData();

    // 🔥 FORCE Angular to detect change
    this.metalLedgerData = [...this.metalLedgerData];

    this.isMetalCardVisible = true;

    // 🔥 NOW open popup
    this.isRateCutVisible = true;
  }

  closeRateCut() {
    this.isRateCutVisible = false;
  }

  onRateCutSubmit(result: any) {
    this.rateCutHistoryRows = result.rows;
    this.rateCutData.payload = result;

    // 1. Physical metal delta (from Silver rows)
    this.rateCutMetalFine = Number(result.metalFineDelta || 0);

    // 2. Fixed weight delta (from Amount rows)
    this.rateCutFixedWeight = Number(result.fixedMetalDelta || 0);

    // 3. Cash delta
    this.rateCutCashAmount = Number(result.cashAmountDelta || 0);

    this.isRateCutApplied = true;
    this.buildMetalLedgerData();
    this.calculateSummary();
    this.isRateCutVisible = false;
  }

  getMetalReceivedValuation(): number {
    return (
      (this.totalMetalReceivedValue || 0) +   // saved (+ clicked)
      (this.liveReceivedValue || 0)            // current typing
    );
  }

  onMetalInputFocus(controlName: string) {
    const ctrl = this.metalDetailsForm.get(controlName);
    if (!ctrl) return;

    const value = ctrl.value;
    if (value === null || value === '' || +value === 0) {
      ctrl.setValue('', { emitEvent: false });
    }
  }

  onMetalInputBlur(controlName: string, decimals: number = 3) {
    const ctrl = this.metalDetailsForm.get(controlName);
    if (!ctrl) return;

    let value = ctrl.value;

    if (value === '' || value === null || isNaN(value)) {
      value = 0;
    }

    ctrl.setValue((+value).toFixed(decimals), { emitEvent: false });
  }

  onInputFocus(form: FormGroup, controlName: string) {
    const ctrl = form?.get(controlName);
    if (!ctrl) return;

    const value = ctrl.value;
    if (value === null || value === '' || +value === 0) {
      ctrl.setValue('', { emitEvent: false });
    }
  }

  onInputBlur(form: FormGroup, controlName: string, defaultValue: any = 0) {
    const ctrl = form?.get(controlName);
    if (!ctrl) return;

    let value = ctrl.value;
    if (value === '' || value === null || isNaN(value)) {
      ctrl.setValue(defaultValue, { emitEvent: false });
    }
  }



  public calculatePrevTotals(): void {
    // 🔥 FIX: Calculate using RAW (signed) values
    const totalSilverRaw = this.previousInvoiceData
      .filter(i => i.isSilverSelected)
      .reduce((sum, i) => sum + (Number(i.silver_raw) || 0), 0);

    const totalCashRaw = this.previousInvoiceData
      .filter(i => i.isCashSelected)
      .reduce((sum, i) => sum + (Number(i.cash_raw) || 0), 0);

    // ✅ CASH → payment form (for summary)
    this.paymentDetailsForm.patchValue({
      in_previous_amount: totalCashRaw.toFixed(2)
    }, { emitEvent: false });

    // ✅ METAL + CASH → ledger (for popup + card)
    this.prevTotals = {
      gold: 0,
      silver: Math.abs(totalSilverRaw), // Display Absolute
      silverType: totalSilverRaw >= 0 ? 'DR' : 'CR', // Pass type
      stone: 0,
      cash: Math.abs(totalCashRaw),     // Display Absolute
      cashType: totalCashRaw >= 0 ? 'DR' : 'CR'
    };

    this.buildMetalLedgerData();
    this.calculateSummary();
  }


  clearPreviousInvoiceBalances() {
    // 1. Get the list of all previous invoices that were CHECKED
    const invoicesToClear = this.previousInvoiceData
      .filter(item => item.isSelected)
      .map(item => ({
        invoice_number: item.invoice_no,
        amount_paid: item.cash_bal,
        // You can add more details like payment method if needed
      }));

    if (invoicesToClear.length === 0) {
      console.log("No previous invoices were checked for clearing.");
      return;
    }

    // 2. Prepare the payload for the server
    const clearPayload = {
      customer_id: this.customerId,
      invoices_to_clear: invoicesToClear
    };

    // 3. Call a new service endpoint
    // 🔥 NOTE: You must create this new API endpoint in your backend!
    this.invoiceService.clearMultipleInvoices(clearPayload).subscribe({
      next: (response) => {
        console.log('✅ Old Invoices Cleared in Database:', response);
      },
      error: (err) => {
        console.error('❌ Failed to clear old invoices:', err);
        // You might not want to stop the main save, but log the error
      }
    });
  }
  //added method for the silver balance fron the payload json column finalBalance to show in the payment pannel previous invoice list
  getSilverBalanceFromPayload(payload: any): number {

    if (!payload) return 0;

    try {

      const data = typeof payload === 'string' ? JSON.parse(payload) : payload;

      if (!data.rows || !Array.isArray(data.rows)) return 0;

      const balanceRow = data.rows.find((r: any) => r.transaction === 'Balance');

      if (!balanceRow) return 0;

      const balance = parseFloat(balanceRow.finalBalance || 0);

      return balanceRow.finalBalanceType === 'CR' ? -balance : balance;

    } catch (e) {
      return 0;
    }
  }
}